
import { Component, Mixins } from "vue-property-decorator";

@Component
export default class VariableParameterMixin extends Mixins() {
  get VariableParameterDictionary(): {[key in string]: string } {
    return {
      "UserName": "職員氏名",
      "UserID": "職員ID",
      "InternalUserID": "内部職員ID",
      "PatientNo": "患者番号",
      "PatientNo-NonCheck": "患者番号(チェックなし)",
      "PatientID": "患者ID",
      "PatientName": "患者・氏名",
      "PatientKana": "患者・ふりがな",
      "PatientBirth": "患者・生年月日",
      "PatientSex": "患者・性別",
      "MedicalDept": this.$wording.common.department,
      "MedicalDept-NonCheck": this.$wording.common.department + "(チェックなし)",
      "ReportOrderNum-NonCheck": "オーダ番号",
      "FormatId": this.$wording.format.name + "ID",
      "%CSV_PATH%": "CSVファイルパス",
      "%BEFORE_VALUE_PATH%": "前回値CSVファイルパス",
      "%VALUE_PATH%": "値XMLファイルパス",
    };
  }
}
